var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-form-builder" }, [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c(
        "aside",
        { staticClass: "col-3 step-form-builder__sidebar" },
        [
          _c("label", { staticClass: "step-form-builder__label" }, [
            _vm._v("Tipo de campo a crear")
          ]),
          _c(
            "div",
            { staticClass: "step-form-builder__palette" },
            _vm._l(_vm.fieldTypeList, function(t) {
              return _c(
                "b-button",
                {
                  key: t.type,
                  staticClass: "step-form-builder__palette-btn",
                  attrs: {
                    size: "sm",
                    variant:
                      t.type === _vm.activeFieldType
                        ? "primary"
                        : "outline-primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.toggleType(t.type)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(t.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "p",
            { staticClass: "step-form-builder__hint" },
            [
              _vm.activeFieldType
                ? [
                    _vm._v(" Haz click sobre el PDF para crear un campo "),
                    _c("strong", [_vm._v(_vm._s(_vm.activeLabel))]),
                    _vm._v(". Se agrega de a uno. ")
                  ]
                : [_vm._v(" Selecciona un tipo para agregar un campo. ")]
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "step-form-builder__actions" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "outline-danger",
                    disabled: !_vm.fields.length
                  },
                  on: { click: _vm.clearFields }
                },
                [_vm._v(" Vaciar campos ")]
              ),
              _c("span", { staticClass: "step-form-builder__count" }, [
                _vm._v(_vm._s(_vm.fields.length) + " campo(s)")
              ])
            ],
            1
          ),
          _c("label", { staticClass: "step-form-builder__label" }, [
            _vm._v("Campos agregados")
          ]),
          _c("FieldListPanel", {
            staticClass: "step-form-builder__list",
            attrs: { fields: _vm.fields, "selected-id": _vm.selectedId },
            on: {
              select: function($event) {
                _vm.selectedId = $event
              },
              delete: _vm.deleteField,
              update: _vm.updateField
            }
          })
        ],
        1
      ),
      _c(
        "main",
        { staticClass: "col-9 step-form-builder__main" },
        [
          _vm.hasMainFile
            ? _c("PdfFieldEditor", {
                attrs: {
                  path: _vm.step.mainFile.path,
                  "active-field-type": _vm.activeFieldType,
                  "allowed-field-types": _vm.allowedFieldTypes,
                  "selected-id": _vm.selectedId,
                  name: _vm.step.mainFile.name
                },
                on: {
                  "update:selectedId": function($event) {
                    _vm.selectedId = $event
                  },
                  "update:selected-id": function($event) {
                    _vm.selectedId = $event
                  },
                  "field-created": _vm.onFieldCreated,
                  loaded: function($event) {
                    return _vm.$emit("loaded")
                  }
                },
                model: {
                  value: _vm.fields,
                  callback: function($$v) {
                    _vm.fields = $$v
                  },
                  expression: "fields"
                }
              })
            : _c("div", { staticClass: "step-form-builder__empty" }, [
                _vm._v(
                  " No hay documento principal cargado para definir campos. "
                )
              ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Definir campos a completar")]),
        _c("p", { staticClass: "text-primary mb-0" }, [
          _vm._v(
            " Posiciona sobre el documento los campos que el responsable del paso de "
          ),
          _c("b", [_vm._v("completitud de datos")]),
          _vm._v(" deberá llenar. ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }